import * as api from '../api';

export const GET_PROGRESS_REPORT = 'GET_PROGRESS_REPORT';
export const GET_FINANCIAL_REPORT = 'GET_FINANCIAL_REPORT';
export const GET_RESOURCE_REPORT = 'GET_RESOURCE_REPORT';
export const GET_MATERIAL_REPORT = 'GET_MATERIAL_REPORT';
export const GET_SCHEDULE_REPORT = 'GET_SCHEDULE_REPORT';
export const GET_OVERALL_ANALYTICS = 'GET_OVERALL_ANALYTICS';
export const GET_PROFITABILITY_REPORT = 'GET_PROFITABILITY_REPORT';
export const SET_REPORT_LOADING = 'SET_REPORT_LOADING';
export const SET_REPORT_ERROR = 'SET_REPORT_ERROR';

export const getProgressReport = (projectId) => async (dispatch) => {
  dispatch({ type: SET_REPORT_LOADING, payload: 'progress' });
  try {
    const { data } = await api.fetchProgressReport(projectId);
    dispatch({ type: GET_PROGRESS_REPORT, payload: data });
  } catch (error) {
    dispatch({ type: SET_REPORT_ERROR, payload: { report: 'progress', error: error.message } });
  }
};

export const getFinancialReport = (projectId) => async (dispatch) => {
  dispatch({ type: SET_REPORT_LOADING, payload: 'financial' });
  try {
    const { data } = await api.fetchFinancialReport(projectId);
    dispatch({ type: GET_FINANCIAL_REPORT, payload: data });
  } catch (error) {
    dispatch({ type: SET_REPORT_ERROR, payload: { report: 'financial', error: error.message } });
  }
};

export const getResourceReport = (projectId) => async (dispatch) => {
  dispatch({ type: SET_REPORT_LOADING, payload: 'resource' });
  try {
    const { data } = await api.fetchResourceReport(projectId);
    dispatch({ type: GET_RESOURCE_REPORT, payload: data });
  } catch (error) {
    dispatch({ type: SET_REPORT_ERROR, payload: { report: 'resource', error: error.message } });
  }
};

export const getMaterialReport = (projectId) => async (dispatch) => {
  dispatch({ type: SET_REPORT_LOADING, payload: 'material' });
  try {
    const { data } = await api.fetchMaterialReport(projectId);
    dispatch({ type: GET_MATERIAL_REPORT, payload: data });
  } catch (error) {
    dispatch({ type: SET_REPORT_ERROR, payload: { report: 'material', error: error.message } });
  }
};

export const getScheduleReport = (projectId) => async (dispatch) => {
  dispatch({ type: SET_REPORT_LOADING, payload: 'schedule' });
  try {
    const { data } = await api.fetchScheduleReport(projectId);
    dispatch({ type: GET_SCHEDULE_REPORT, payload: data });
  } catch (error) {
    dispatch({ type: SET_REPORT_ERROR, payload: { report: 'schedule', error: error.message } });
  }
};

export const getOverallAnalytics = (projectId) => async (dispatch) => {
  dispatch({ type: SET_REPORT_LOADING, payload: 'analytics' });
  try {
    const { data } = await api.fetchOverallAnalytics(projectId);
    dispatch({ type: GET_OVERALL_ANALYTICS, payload: data });
  } catch (error) {
    dispatch({ type: SET_REPORT_ERROR, payload: { report: 'analytics', error: error.message } });
  }
};

export const getProfitabilityReport = () => async (dispatch) => {
  dispatch({ type: SET_REPORT_LOADING, payload: 'profitability' });
  try {
    const { data } = await api.fetchProfitabilityReport();
    dispatch({ type: GET_PROFITABILITY_REPORT, payload: data.data });
  } catch (error) {
    dispatch({ type: SET_REPORT_ERROR, payload: { report: 'profitability', error: error.message } });
  }
};
